import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { SettingsPage } from "@/features/me/SettingsPage";
import { SETTINGS_TABS } from "@/features/me/settingsTabs";

export const Route = createFileRoute("/app/me/settings")({
  validateSearch: z.object({ tab: z.enum(SETTINGS_TABS).optional().catch(undefined) }),
  component: SettingsPage,
});
